import { AlertTriangle } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { STORE } from "@/constants/testIds";
import { DISCLAIMER_TEXT } from "@/data/content";

const Container = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </div>
);

const POINTS = [
  "Not affiliated with PSI, IDFPR, the State of Illinois, or any real estate commission.",
  "All practice questions are original and based on public exam-topic guidance and Illinois real estate concepts.",
  "We do not provide, copy, or claim to provide actual exam questions.",
  "This is a study aid — it does not replace required pre-license education, official exam bulletins, or legal guidance.",
  "No pass guarantee.",
];

export default function Disclaimer() {
  return (
    <div data-testid={STORE.disclaimerPage} className="bg-[var(--ibp-offwhite)]">
      <section className="bg-[var(--ibp-navy-950)] py-12 text-white sm:py-16">
        <Container>
          <SectionHeading tone="navy" kicker="Legal" title="Disclaimer" />
        </Container>
      </section>

      <section className="py-14 sm:py-20">
        <Container>
          <div className="mx-auto max-w-3xl">
            <div
              data-testid={STORE.disclaimerAlert}
              className="flex items-start gap-3 rounded-2xl border border-[color:rgba(183,121,31,0.35)] bg-[color:rgba(214,162,30,0.10)] p-5"
            >
              <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-[#B7791F]" />
              <p className="text-sm leading-6 text-[var(--ibp-ink)]">
                {DISCLAIMER_TEXT}
              </p>
            </div>

            <div className="mt-8 rounded-2xl border border-[color:rgba(10,27,51,0.12)] bg-white p-7 shadow-[0_10px_30px_rgba(7,20,39,0.06)]">
              <h2 className="font-[var(--font-heading)] text-lg font-semibold text-[var(--ibp-ink)]">
                Key points
              </h2>
              <ul className="mt-4 space-y-3 text-sm leading-6 text-[color:rgba(11,18,32,0.78)]">
                {POINTS.map((p) => (
                  <li key={p} className="flex gap-3">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#B7791F]" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
